import React from "react";
import { Box, Typography } from "@mui/material";

interface DetailInfoFieldProps {
  label: string;
  value: React.ReactNode;
  isLink?: boolean;
  href?: string;
}

/**
 * Reusable info field component
 * Used for displaying labeled information in detail cards
 */
export const DetailInfoField: React.FC<DetailInfoFieldProps> = ({
  label,
  value,
  isLink = false,
  href,
}) => {
  return (
    <Box>
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          textTransform: "uppercase",
          fontWeight: 600,
          letterSpacing: 0.5,
        }}
      >
        {label}
      </Typography>
      <Typography variant="body1" sx={{ fontWeight: 600, mt: 0.5 }}>
        {isLink && href ? (
          <a
            href={href}
            style={{
              color: "#1976d2",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            {...(href.startsWith("http") && {
              target: "_blank",
              rel: "noopener noreferrer",
            })}
          >
            {value}
          </a>
        ) : (
          value
        )}
      </Typography>
    </Box>
  );
};
